import { SUBSCRIPTION_STEPS } from ".";
import Documents from "./widgets/Documents";
import SignatureWaiting from "./widgets/SignatureWaiting";
import Subscription from "./widgets/Subscription";
import SubscriptionDone from "./widgets/SubscriptionDone";

const View = ({
  data,
  translation,
  updateSubscription,
  initialValues,
  totalPrice,
  setActive,
  currentStep,
  setCurrentStep,
}) => {
  const { subscription } = data;
  const onNext = () => {
    console.log("<< onNext >>");
  };

  const onBack = () => {
    console.log("<< onBack >>");
  };

  return (
    <>
      {currentStep === SUBSCRIPTION_STEPS.SIGNATURE_WAITING && (
        <SignatureWaiting subscription={subscription} totalPrice={totalPrice} />
      )}
      {currentStep === SUBSCRIPTION_STEPS.SUBSCRIPTION_DONE && (
        <SubscriptionDone subscription={subscription} totalPrice={totalPrice} />
      )}
      {currentStep === SUBSCRIPTION_STEPS.VIEW_DOCUMENTS && (
        <Documents
          subscription={subscription}
          initialValues={initialValues}
          onNext={onNext}
          onBack={onBack}
          updateSubscription={updateSubscription}
          totalPrice={totalPrice}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
        />
      )}
      {currentStep === SUBSCRIPTION_STEPS.INITIAL && (
        <Subscription
          subscription={subscription}
          initialValues={initialValues}
          onNext={onNext}
          onBack={onBack}
          updateSubscription={updateSubscription}
          totalPrice={totalPrice}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
        />
      )}
    </>
  );
};

export default View;
